import { render, staticRenderFns } from "./R27EventosSubsecuentes.vue?vue&type=template&id=2b3f4abf&scoped=true&"
import script from "./R27EventosSubsecuentes.vue?vue&type=script&lang=js&"
export * from "./R27EventosSubsecuentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3f4abf",
  null
  
)

export default component.exports